import { Flex, Icon, Text } from "@chakra-ui/react";
import { IoWarningOutline } from "react-icons/io5";

interface UndelegationMessageProps {
  message: string;
}

const UndelegationMessage = ({ message }: UndelegationMessageProps) => {
  return (
    <Flex
      p="12px 16px"
      borderRadius="8px"
      alignItems="center"
      w="100%"
      bg="warning"
      color="textPrimary"
      _dark={{
        color: "#060710",
      }}
    >
      <Icon as={IoWarningOutline} mr="14px" />
      <Text
        fontWeight="400"
        fontSize={{ base: "12px", lg: "14px" }}
        lineHeight={{ base: "18px", lg: "20px" }}
      >
        {message}
      </Text>
    </Flex>
  );
};

export default UndelegationMessage;
